<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <FeesForWeightAndNoiseForm
        ref="feesForWeightAndNoiseForm"
        v-model="feesForWeightAndNoiseForm"
        label-width="10em"
        formMode="search"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForWeightAndNoiseForm from '@/components/organisms/dialog/calculation/FeesForWeightAndNoiseForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForWeightAndNoiseForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      feesForWeightAndNoiseForm: {
        registration_symbol: undefined,
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: undefined,
        route_code: undefined,
        callsign: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        model_code: undefined,
        landing_fee_without_tax: undefined,
        landing_fee_tax: undefined,
        landing_fee_with_tax: undefined,
        tax: undefined,
        taxation: undefined,
        flight_purpose_code: undefined,
        aircraft_type: undefined,
        weight: undefined,
        noise_level: undefined,
        count: undefined,
        exemption_code: undefined,
        exemption_rate: undefined,
        unit_fee: undefined,
        // landingFeeBeforeExemption: undefined,
        manual_data_only: false,
        automatic_data_only: false
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.feesForWeightAndNoiseForm.clearFields()
    },
    clickSearch () {
      this.$refs.feesForWeightAndNoiseForm.validate()
        .then((valid) => {
          sessionStorage.setItem('feesForWeightAndNoiseSearchCond', JSON.stringify(this.feesForWeightAndNoiseForm))
          this.dialogVisible = false
          this.$emit('search', this.feesForWeightAndNoiseForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForWeightAndNoiseSearchCond'))
      this.$nextTick(() => {
        this.$refs.feesForWeightAndNoiseForm.clearFields()
        if (searchCond) {
          Object.keys(this.feesForWeightAndNoiseForm).forEach((x) => {
            this.$set(this.feesForWeightAndNoiseForm, x, searchCond[x])
          })
          if (!this.feesForWeightAndNoiseForm.manual_data_only) {
            this.feesForWeightAndNoiseForm.manual_data_only = false
          }
          if (!this.feesForWeightAndNoiseForm.automatic_data_only) {
            this.feesForWeightAndNoiseForm.automatic_data_only = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
